import BaseModelInvestmentValuation from "@/models/BaseModelInvestmentValuation.js";

export default {
	list: BaseModelInvestmentValuation.list,
	// columns: BaseModelInvestmentValuation.columns,
    columns: {
        Id: {
			class: 'id',
			dataName: 'Id',
			type: 'number',
			title: 'Id',
			width: 100,
			hidden: true,
			readOnly: false
		},
		InvestmentId: {
			class: "lookup",
			dataName: 'InvestmentId',
			type: 'number',
			title: 'Investment Id',
			width: 100,
			hidden: true,
			readOnly:false
		},
		InvestmentTitle: {
			class: "lookup",
			dataName: 'Investment/Title',
			type: 'string',
			title: 'Investment',
			width: 100,
			hidden: true,
			readOnly: true
		},
		TaxYear: {
			class: "choice",
			dataName: 'TaxYear',
			type: 'string',
			title: 'Tax Year',
			dropdown:true,
			validation: { required: true},
			width: 100,
			hidden: false,
			readOnly: false
		},
		TaxQuarter: {
			class: "choice",
			dataName: 'TaxQuarter',
			type: 'string',
			title: 'Tax Quarter',
			dropdown:true,
			validation: { required: true},
			width: 100,
			hidden: false,
			readOnly:false
		},
		TaxYearQuarter: {
			class: "value",
			dataName: 'TaxYearQuarter',
			type: 'string',
			title: 'Tax Period',
			width: 100,
			hidden: true,
			readOnly:true
		},
		ProjectedValue: {
			class: "value",
			dataName: 'ProjectedValue',
			type: 'number',
			title: 'Projected Value',
			validation: { min: 0, required: true},
			template: '#=kendo.toString(ProjectedValue, "c")#',
			width: 100,
			hidden: false,
			readOnly: false
		},
		CurrentValue: {
			class: "value",
			dataName: 'CurrentValue',
			type: 'number',
			title: 'Current Value',
			template: '#=kendo.toString(CurrentValue, "c")#',
			validation: { min: 0, required: true},
			width: 100,
			hidden: false,
			readOnly: false
		},
		Note: {
			class: 'value',
			dataName: 'Note',
			type: 'string',
			title: 'Note',
			width: 100,
			hidden: true,
			readOnly:false
		}
    },
    grid: {
		gridId:'InvestmentValuationFormGrid',
        height: 0,
		groupable : false,
		editable : true,
		selectable : true,
		filterable : false,
		resizable : false,
		noRecords : true,
		reorderable : false,
		columnMenu : false,		
		pageable:false,
		edit:false,
		delete: true,
	}
}